import axios from 'lib/axios'

export const getCompaniesApi = ({ q, questionnaireType }) =>
  axios.get(`/questionnaire/companies?query=${q}&questionnaire_type=${questionnaireType}`)

export const getQuestionnaireFormsApi = ({ params }) =>
  axios.get('/questionnaire_forms', {
    params,
  })

export const getBuildingQuestionnaireGenericFormApi = ({ building_id }) =>
  axios.get(`/api/questionnaire_form/generic`, { params: { building_id } })

export const getQuestionnaireBuildingApi = (id) => axios.get(`/questionnaire/buildings/${id}`)

export const createQuestionnaireRequesterApi = (values) =>
  axios.post(`/questionnaire_requests/create_questionnaire_request`, values)

export const postPurchaseQuestionnaire = ({
  hashedId,
  purchaserToken,
  user_payment_method_id,
  payment_method_id,
  save_payment_method,
  payment_token,
}) =>
  axios.post(`/questionnaire_requests/${hashedId}/purchase/${purchaserToken}`, {
    user_payment_method_id,
    payment_method_id,
    save_payment_method,
    payment_token,
  })

export const postSetupIntent = ({ hashedId, purchaserToken, value }) =>
  axios.post(`/questionnaire_requests/${hashedId}/setup_intent/${purchaserToken}`, value)
